<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-bind:class="className">
            <div class="modal-overlay" @click="back()"></div>
            <div class="modal">
                        <article v-if="resource">

                    <header>
                        <figure>
                            <i v-if="!resource.picture" class="icon icon-file-group"></i>
                            <img v-if="resource.picture" :src="resource.picture.url+'/fit/100x100'"/>
                        </figure>
                        <div>
                            <span class="breadcrumb">
                                Contrat <i class="icon icon-icon_arrow-right"></i> Edit
                            </span>
                            <h1>{{ resource.reference ? resource.reference : 'Nouveau' }}</h1>

                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                            <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                        </div>
                    </header>

                    <main>

                         <languages :translations="resource.translations" :localesLoaded="localesLoaded" :locales="locales" v-model="locale"></languages>

                        <tabs :options="{ useUrlFragment: false }">
                            <tab name="Information">

                              <fieldset>
                                <h3>Détail du contrat</h3>
                                <p class="headline"></p>

                                <div style="display: flex; align-items: center;">
                                    <div class="order-steps">
                                        <ul :class="resource.new_status">
                                            <li class="new" @click="setStatus('new')" v-bind:class="{'is-completed': resource.new_status == 'completed'}">
                                                <span>Souscription <em>{{ formatDate(resource.created_at) }}</em></span>
                                                <i class="icon icon-icon_email"></i>
                                            </li>
                                            <li @click="setStatus('sent')" v-bind:class="{'sent is-completed': resource.new_status == 'completed', 'sent': resource.new_status == 'sent'}">
                                                <span>Envoyé <em>{{ formatDate(resource.sent_at) }}</em></span>
                                                <i class="icon icon-order-success"></i>
                                            </li>
                                            <li @click="setStatus('completed')" v-bind:class="{'completed is-completed': resource.new_status == 'completed', 'completed': resource.new_status == 'completed'}">
                                                <span>Payé <em>{{ formatDate(resource.paied_at) }}</em></span>
                                                <i class="icon icon-check"></i>
                                            </li>
                                        </ul>
                                    </div>

                                    <div style="padding: 0 10px; white-space: nowrap; text-align: center;">
                                        <a href="#" class="print-document" @click="printOffer()">
                                            <i class="icon icon-file-group"></i>
                                            <span>Imprimer l'offre</span>
                                        </a>
                                    </div>

                                    <div style="padding: 0 10px; white-space: nowrap; text-align: center;">
                                        <a :href="resource.card_link" target="_blank" class="print-document" v-bind:class="{'disabled':resource.new_status != 'completed'}">
                                            <i class="icon icon-card"></i>
                                            <span>Imprimer la carte</span>
                                        </a>
                                    </div>

                                    <div style="padding: 0 10px; white-space: nowrap; text-align: center;">
                                        <a href="#" @click="printContract()" class="print-document" v-bind:class="{'disabled':resource.new_status != 'completed'}">
                                            <i class="icon icon-file-group-check"></i>
                                            <span>Imprimer le contrat</span>
                                        </a>
                                    </div>

                                </div>

                              </fieldset>


                              <fieldset>
                                <h3>Informations</h3>
                                <p class="headline"></p>

                                <form-scopes label='Scopes' v-model="resource"></form-scopes>

                                <form-autocomplete label="Délégué commercial" v-model="resource.protractor" :default="resource.protractor_id" :service="ProtractorService"></form-autocomplete>

                                <form-text label="Prénom de l'agent" v-model="resource.agent_firstname"></form-text>
                                <form-text label="Nom de l'agent" v-model="resource.agent_lastname"></form-text>
                                <form-text label="Email de l'agent" v-model="resource.agent_email"></form-text>

                                <hr>


                                <form-select label="Genre" multiple="false" v-model="resource.gender" :default="resource.gender" :options="genders" required="true"></form-select>

                                <form-text label="Prénom" v-model="resource.firstname" required="true"></form-text>

                                <form-text label="Nom" v-model="resource.lastname" required="true"></form-text>

                                <form-date label="Date naissance" v-model="resource.birthdate" required="true"></form-date>

                                <form-text label="AVS" v-model="resource.avs"></form-text>

                                <form-select label="Locales" multiple="false" v-model="resource.locale" :default="resource.locale" :options="$store.state.locales"></form-select>

                                <form-text label="Ville d'origine" v-model="resource.origin_city" required="true"></form-text>

                                <form-select label="Pays d'origine" multiple="false" v-model="resource.origin_country" :default="resource.origin_country_id" :options="$store.state.countries" required="true"></form-select>

                                <form-text label="Email" v-model="resource.email"></form-text>

                                <form-phone label="Phone" v-model="resource.phone"></form-phone>

                                <form-address
                                        label="Facturation"
                                        v-model="resource.address_billing"></form-address>

                              </fieldset>

                            </tab>
                            <tab name="Détail du contrat">

                              <fieldset>
                                <h3>Détail du contrat</h3>
                                <p class="headline"></p>

                                <form-select label="Pays" multiple="false" v-model="resource.country" :default="resource.country_id" :options="$store.state.countries" required="true"></form-select>

                                <form-select label="Devise par défaut" multiple="false" v-model="resource.currency" :default="resource.currency_id" :options="$store.state.currencies"></form-select>

                                <form-number label="Capital garanti" v-model="resource.amount_capital" :step="0.05" required="true"></form-number>

                                <form-number label="Total" v-model="resource.amount_total" :step="0.05" required="true"></form-number>

                                <group-line-3>
                                <form-toggle label="Mode de paiement" v-model="resource.is_monthly_payments"></form-toggle>
                                <form-text label="Nombre de mensualités" v-model="resource.total_months" v-show="resource.is_monthly_payments" suffix="Mois"></form-text>
                                <form-text label="Coûts des mensualités" v-model="(resource.amount_total / resource.total_months).toFixed(2)" v-show="resource.is_monthly_payments" :suffix="' CHF / mois'" :readonly="true"></form-text>
                                </group-line-3>

                                <form-toggle label="Rappatriement pour accident" v-model="resource.has_option_accident_repatriation"></form-toggle>

                                <form-toggle label="Rappatriement pour maladie" v-model="resource.has_option_sickness_repatriation"></form-toggle>

                                <form-medias label="Fichiers liés" v-model="resource.medias"></form-medias>

                              </fieldset>

                            </tab>
                        </tabs>

                    </main>
                    <footer>
                    </footer>
                </article>

            </div>
        </div>
    </transition>
</template>
<script>


    import ContractService from './ContractService.js';

    import ComponentAddress from "../../../components/Address.vue";
    import ComponentAttributes from "../../../components/Attributes.vue";

    import ProtractorService from './../protractor/ProtractorService.js';

    import Edit from '../../../layouts/Edit.vue';

    export default {
        extends: Edit,
        components: {
            'component-address': ComponentAddress,
            'component-attributes': ComponentAttributes,
        },
        data () {
            return {
                attributes: [],
                resource: {
                    companies: [],
                    user: {
                        workspaces: []
                    }
                },
                options: [],
                scopes: [],
                genders: [
                    {id: 'f', name: 'Madame'},
                    {id: 'm', name: 'Monsieur'}
                ],
                isLoading: false,
                ProtractorService: null
            }
        },
        mounted: function(){
            this.ProtractorService = ProtractorService;
        },
        methods:{
            setStatus: function(status){
                this.resource.new_status = status
                this.$forceUpdate()
            },
            resourceLoaded: function(){
                this.localesLoaded = true;
                this.resource.new_status = this.resource.status || 'new'
                this.resource.country_id = this.resource.country_id || 'CH'
                this.resource.origin_country_id = this.resource.origin_country_id || 'CH'
                this.resource.locale = this.resource.locale || 'fr'
                this.resource.currency_id = this.resource.currency_id || 'CHF'
            },
            beforeUpdate: function(Resource){
                this.resource.user = this.resource.user && this.resource.user.email ? this.resource.user : null
                return true
            },
            getResource: function(){
                return ContractService
            },
            formatDate: function(value){

                if( value === undefined || value === null ){ return '-'; }

                var d = new Date(value);
                return ("0" + d.getDate()).slice(-2) + "." + ("0"+(d.getMonth()+1)).slice(-2) + "." + d.getFullYear();

            },
            printOffer: function(){
                var d = new Date();
                d = ("0" + d.getDate()).slice(-2) + "." + ("0"+(d.getMonth()+1)).slice(-2) + "." + d.getFullYear();

                let date = prompt("Date du document", d);
                if( date ){
                    window.open(this.resource.offer_link + "?date=" + date);
                }
                return false;
            },
            printContract: function(){
                var d = new Date();
                d = ("0" + d.getDate()).slice(-2) + "." + ("0"+(d.getMonth()+1)).slice(-2) + "." + d.getFullYear();

                let date = prompt("Date du document", d);
                if( date ){
                    window.open(this.resource.document_link + "?date=" + date);
                }
                return false;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/serevita/contract/Edit.vue